var map = {
	"./afb-color.svg": 1497,
	"./alb-color.svg": 1498,
	"./all.svg": 1499,
	"./amb-color.svg": 1500,
	"./arg.svg": 1501,
	"./aus.svg": 1502,
	"./bank-icon.svg": 1503,
	"./bankdemo-color.svg": 1504,
	"./bel.svg": 1505,
	"./bimb-color.svg": 1506,
	"./bkr-color.svg": 1507,
	"./bra.svg": 1508,
	"./bsn-color.svg": 1509,
	"./can.svg": 1510,
	"./checked-white.png": 1511,
	"./cimb-color.svg": 1512,
	"./cimb-icon.svg": 1513,
	"./citi-color.svg": 1514,
	"./cmr.svg": 1515,
	"./crc.svg": 1516,
	"./cro.svg": 1517,
	"./den.svg": 1518,
	"./ecu.svg": 1519,
	"./eng.svg": 1520,
	"./esp.svg": 1521,
	"./fav-gray.png": 1522,
	"./fav-icon-active.png": 1523,
	"./fav-icon.png": 1524,
	"./fav-red.png": 1525,
	"./fra.svg": 1526,
	"./game-icon.svg": 1527,
	"./games-active-m.svg": 1528,
	"./games-m.svg": 1529,
	"./ger.svg": 1530,
	"./gha.svg": 1531,
	"./hlb-color.svg": 1532,
	"./hlb-icon.svg": 1533,
	"./hsbc-color.svg": 1534,
	"./irn.svg": 1535,
	"./jpn.svg": 1536,
	"./kor.svg": 1537,
	"./ksa.svg": 1538,
	"./kwh-color.svg": 1539,
	"./latest-icon-active.png": 1540,
	"./latest-icon.png": 1541,
	"./lc-active-m.svg": 1542,
	"./lc-icon.svg": 1543,
	"./lc-m.svg": 1544,
	"./lottery-active-m.svg": 1545,
	"./lottery-icon.svg": 1546,
	"./lottery-m.svg": 1547,
	"./love.svg": 1548,
	"./mar.svg": 1549,
	"./mbb-color.svg": 1550,
	"./mex.svg": 1551,
	"./ned.svg": 1552,
	"./ocbc-color.svg": 1553,
	"./ocbc-icon.svg": 1554,
	"./p2p-active-m.svg": 1555,
	"./p2p-icon.svg": 1556,
	"./p2p-m.svg": 1557,
	"./pbb-color.svg": 1558,
	"./pol.svg": 1559,
	"./por.svg": 1560,
	"./price-high.svg": 1561,
	"./price-low.svg": 1562,
	"./qat.svg": 1563,
	"./rhb-color.svg": 1564,
	"./rhb-icon.svg": 1565,
	"./scb-color.svg": 1566,
	"./sen.svg": 1567,
	"./slot-active-m.svg": 1568,
	"./slot-icon.svg": 1569,
	"./slot-m.svg": 1570,
	"./sport-active-m.svg": 1571,
	"./sport-m.svg": 1572,
	"./sports-icon.svg": 1573,
	"./srb.svg": 1574,
	"./star.svg": 1575,
	"./sui.svg": 1576,
	"./trx-icon.svg": 1577,
	"./trx.svg": 1578,
	"./tun.svg": 1579,
	"./uob-color.svg": 1580,
	"./uru.svg": 1581,
	"./usa.svg": 1582,
	"./usdc.svg": 1583,
	"./usdt.svg": 1584,
	"./ustd-icon.svg": 1585,
	"./wal.svg": 1586,
	"./x33-logo-b.svg": 1587,
	"./x33-square-icon.svg": 1588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1496;